import {GetBanners, GetBannersRequest, GetBannersResponse} from 'domain/usecases';

import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';

export class RemoteGetBanners implements GetBanners {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetBannersResponse>,
	) {}

	async post({signal, ...params}: GetBannersRequest): Promise<GetBannersResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
